import { eng } from './eng/translation';
import { ro } from './ro/translation';

const resources = {
    eng: eng,
    ro: ro,
};

export default resources;
